import { ref, toRefs } from 'vue';
import { useRequestApi, useRequestWithSnackBar } from '@/composition/fetch';
import { LicenseForm } from '@/api/license/licenseApi';
export const useLicenseForm = (api, licenseForm = new LicenseForm()) => {
    const form = ref(licenseForm);
    const { request, state } = useRequestApi(api, 0);
    const { loading } = toRefs(state);
    const rules = {
        company: [(v) => !!v || 'Company is Required'],
        product: [(v) => !!v || 'Product is Required'],
        licenseCount: [
            (v) => v > 0 || 'License Count must be greater than 0.'
        ],
        endDate: [(v) => !!v || 'endDate is Required']
    };
    return {
        form,
        setForm(newForm) {
            form.value = { valid: false, ...newForm };
        },
        rules,
        loading,
        save: () => { return useRequestWithSnackBar(request)(form.value); }
    };
};
